import { Minus, Plus } from "lucide-react"
import { Button } from "@/components/ui/button"
import type { IntentionDetail } from "../types"

interface IntentionHeaderProps {
  intention: IntentionDetail
  isToggling: boolean
  onToggle: () => void
}

export function IntentionHeader({ intention, isToggling, onToggle }: IntentionHeaderProps) {
  return (
    <div className="py-4 mt-1">
      <div className="flex items-center gap-4 flex-wrap">
        <h1 className="text-[30px] leading-normal font-bold text-white uppercase">
          {intention.name}
        </h1>
        <Button
          onClick={onToggle}
          disabled={isToggling}
          variant={intention.isSaved ? "default" : "outline"}
          className={`text-[12px] leading-[20px] border border-white uppercase rounded-full ${
            intention.isSaved ? "text-white -ms-1 mb-1" : " text-white !py-5 !px-3 "
          }`}
          size="xs"
        >
          {intention.isSaved ? (
            <Minus className="h-4 w-4" />
          ) : (
            <>
              <Plus className="h-4 w-4 mr-1.5" />
              Add to My Intentions
            </>
          )}
        </Button>
      </div>
      {intention.description && (
        <p className="mt-3 text-sm text-primary max-w-2xl">{intention.description}</p>
      )}
    </div>
  )
}
